import $ from 'jquery';

$( '.js-mobile-nav-toggle' ).on( 'click', function() {
	const nav = $( '.js-mobile-nav' );

	if ( nav.hasClass( 'is-expanded' ) ) {
		nav.removeClass( 'is-expanded' ).slideUp( 300 );
	} else {
		nav.toggleClass( 'is-expanded' ).slideToggle( 300 );
	}
} );
